import React from 'react';
import PropTypes from 'prop-types';
import Input from 'components/Input';

class CiAlphaFieldComponent extends React.PureComponent {

  render () {
    return (
      <Input
        {...this.props}
        label="="
        labelClassName="main-input__label width-auto"
        wrapperClassName="relative width-48 flex baseline justify-end iconTop"
        inputClassName="main-input__input max-85 pr-5 ml-3 mt-20 mb-20"
      />
    );
  }
}

CiAlphaFieldComponent.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    onChange: PropTypes.func.isRequired
  }).isRequired,

  meta: PropTypes.any.isRequired
};

export default CiAlphaFieldComponent;
